import { render, staticRenderFns } from "./waitCollectionList.vue?vue&type=template&id=7a0cc662&scoped=true"
import script from "./waitCollectionList.vue?vue&type=script&lang=js"
export * from "./waitCollectionList.vue?vue&type=script&lang=js"
import style0 from "./waitCollectionList.vue?vue&type=style&index=0&id=7a0cc662&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0cc662",
  null
  
)

export default component.exports